import React, { FunctionComponent } from 'react';
import Modal from '../../../../../../common/components/presentation/Modal';
import { DialogActions, DialogContent, Typography } from '@material-ui/core';
import Price from '../../../../../../common/components/presentation/Price';
import ButtonOptionToggle from '../../../../../../common/components/presentation/Button/ButtonOptionToggle';
import accessoryPackModalStyles from './accessoryPackModalStyles';
import DialogTitle from '../../../../../../common/components/presentation/dialogTitle/DialogTitle';
import { IPrice } from '../../../../../../../../common/model/IPrice';
import AccessoriesList from '../../accessories/accessoriesList/AccessoriesList';
import IExtendedAccessory from '../../../../../model/accessories/IExtendedAccessory';
import { IPriceDisplay } from '../../../../../../common/model/IPlatformConfig';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IAccessoryPackModalProps {
  id: string;
  name: string;
  primaryPrice: IPrice;
  secondaryPrice?: IPrice;
  accessories: IExtendedAccessory[];
  isSelected: boolean;
  isOpen: boolean;
  onClose: () => any;
  onToggle?: (id: string) => any;
  priceDisplay: IPriceDisplay;
  isMulticurrency: boolean;
}

const AccessoryPackModal: FunctionComponent<IAccessoryPackModalProps> = ({
  id,
  name,
  primaryPrice,
  secondaryPrice,
  accessories,
  isSelected,
  isOpen,
  onClose,
  onToggle,
  priceDisplay,
  isMulticurrency,
}) => {
  const styles = accessoryPackModalStyles();

  return (
    <Modal open={isOpen} onClose={onClose} data-test={'container:accessory-pack'}>
      <DialogTitle title={name} className={styles.modalTitleContainer} data-test={'text:accessory-pack:title'}>
        <Typography component={'span'} color={'textPrimary'} data-test={'text:accessory-pack:price'} variant="body1">
          <Translation id={'spc.customise.accessoryPackDetails.priceLabel'} />
        </Typography>
        <Typography component={'span'} className={styles.price} variant="body1">
          <Price
            color={'textPrimary'}
            component={'span'}
            price={primaryPrice?.basePrice}
            currency={primaryPrice?.currency}
            variant="body1"
            decimals={priceDisplay.primaryOptions.decimalScale}
          />
        </Typography>
        {isMulticurrency && secondaryPrice && (
          <Typography
            component={'span'}
            className={styles.priceSecondary}
            data-test={'text:accessory-pack:title:secondary'}
            variant="body1"
          >
            <Typography component={'span'} color={'textPrimary'} variant="body1">
              <Translation id={'spc.customise.accessoryPackDetails.priceSeparator'} />
            </Typography>
            <Price
              data-test="price:accessory-pack:secondary"
              color={'textPrimary'}
              component={'span'}
              price={secondaryPrice?.basePrice}
              currency={secondaryPrice?.currency}
              variant="body1"
              decimals={priceDisplay.secondaryOptions?.decimalScale}
            />
          </Typography>
        )}
      </DialogTitle>

      <DialogContent className={styles.modalContentContainer} data-test={'container:accessory-pack:accessories'}>
        <AccessoriesList accessories={Object.values(accessories)} isSelectable={false} inModal={true} />
      </DialogContent>

      <DialogActions className={styles.modalActionsContainer}>
        <ButtonOptionToggle
          className={styles.toggleButton}
          color={'primary'}
          label={'spc.productConfigure.options.button.add'}
          labelRemove={'spc.productConfigure.options.button.remove'}
          onClick={() => onToggle(id)}
          isEnabled={isSelected}
          data-test={'button:accessory-pack:toggle'}
        />
      </DialogActions>
    </Modal>
  );
};

export default AccessoryPackModal;
